import { GridColDef } from "@mui/x-data-grid";

export const addressTypeColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
